import { render, staticRenderFns } from "./AdminShellSidebar.vue?vue&type=template&id=01d6c6d4&scoped=true"
import script from "./AdminShellSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminShellSidebar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminShellSidebar.vue?vue&type=style&index=0&id=01d6c6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d6c6d4",
  null
  
)

export default component.exports